import { render, staticRenderFns } from "./PharBased.vue?vue&type=template&id=09bfc36f&scoped=true"
import script from "./PharBased.vue?vue&type=script&lang=js"
export * from "./PharBased.vue?vue&type=script&lang=js"
import style0 from "./PharBased.vue?vue&type=style&index=0&id=09bfc36f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bfc36f",
  null
  
)

export default component.exports